<button
  [class.btn]="!noBase"
  class="{{ class }} {{ buttonTypeClass }} {{ buttonSizeClass }}"
  [class.cursor-not-allowed]="loading$"
  [type]="type"
  [style.line-height]="lineHeight"
  [class.outline]="outline"
  [disabled]="disabled">

  @if (!loading$) {
    <span class="insert-container" #ref><ng-content></ng-content></span>
    @if (!ref.hasChildNodes()) {
      <span class="btn-content-container">
        @if (icon) {
          <app-icon class="icon mr-{{ iconSpacing }}" [icon]="icon"></app-icon>
        }
        @if (!localizeTxt) {
          <span class="txt">{{ btnTxt }}</span>
        }
        @if (localizeTxt) {
          <span class="txt">{{ btnTxt | localizeText : btnTxt }}</span>
        }
      </span>
    }
  } @else {
    <app-button-loader></app-button-loader>
  }
</button>
